/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { CreateRepDTO } from 'data/from-data/create-customer-rep-form.data';
import { jobBoardAPI } from './base';
import { ContactPerson } from 'data/users';
import { JobClient } from 'data/users';

const customers = {
  getAll: '/customer-representative',
  getCustomer: '/customer-representative/:{id}',
  create: '/customer-representative',
  search: '/customer/search'
};

export const GET_CUSTOMERS_REP_QUERY = async (): Promise<
  AxiosResponse<ContactPerson[]>
> => {
  return (await jobBoardAPI.get(customers.getAll)).data;
};
export const CREATE_CUSTOMER_REP = async (
  formData: CreateRepDTO
): Promise<AxiosResponse<ContactPerson>> => {
  return jobBoardAPI.post(customers.create, formData);
};
export const GET_CUSTOMERS_REP = async (
  customerId: string
): Promise<AxiosResponse<ContactPerson>> => {
  const endpoint = customers.getCustomer.replace(':{id}', customerId);
  return (await jobBoardAPI.get(endpoint)).data;
};

export const UPDATE_CUSTOMERS_REP = async ({
  customerId,
  formData
}: {
  customerId?: string;
  formData?: CreateRepDTO;
}): Promise<AxiosResponse<ContactPerson>> => {
  const endpoint = `/customer-representative/${customerId}`;

  return jobBoardAPI.patch(endpoint, formData);
};

export const DELETE_CUSTOMERS_REP = async (
  customerId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/customer-representative/${customerId}`;
  return jobBoardAPI.delete(endpoint);
};

export const SEARCH_CUSTOMERS = async (
  query: string
): Promise<AxiosResponse<JobClient[]>> => {
  return (await jobBoardAPI.get(`${customers.search}?q=${query}`)).data;
};
